import { PUBLIC_LOCALES, getLocale, setLocale } from "../../lib/i18n";

export default function LangSwitcher({ locale, onChange, dark }) {
  const baseLight = "inline-flex items-center gap-0 border border-gray-200 rounded-sm overflow-hidden text-[10px] font-mono-tab";
  const baseDark = "inline-flex items-center gap-0 border border-[var(--ag-border)] rounded-sm overflow-hidden text-[10px] font-mono-tab";
  return (
    <div className={dark ? baseDark : baseLight} data-testid="lang-switcher">
      {PUBLIC_LOCALES.map((l) => {
        const active = locale === l.code;
        let cls;
        if (dark) {
          cls = `px-2 py-1 transition-colors ${active ? "bg-[var(--ag-gold)] text-[var(--ag-midnight)] font-bold" : "bg-transparent text-[var(--ag-text-dim)] hover:text-white hover:bg-[var(--ag-midnight-soft)]"}`;
        } else {
          cls = `px-2 py-1 transition-colors ${active ? "bg-[#111827] text-white" : "bg-white text-gray-500 hover:bg-gray-50"}`;
        }
        return (
          <button key={l.code} type="button"
            onClick={() => { setLocale(l.code); onChange(l.code); }}
            className={cls}
            data-testid={`lang-${l.code}`}>
            {l.label}
          </button>
        );
      })}
    </div>
  );
}

export { getLocale };
